import React from 'react';
import './WhereWeWork.css';
import afgMap from '../images/afg_ai.jpg';

const Freelancing: React.FC = () => {
  const scopeOfWork = [
    {
      title: 'AI & Digital Skills',
      description: 'Empowering Afghan women and youth with future-ready digital skills for sustainable economic independence.',
      icon: 'fas fa-laptop-code'
    }
  ];

  return (
    <div className="where-we-work-page">

      <section className="clean-map-section">
        <div className="container">
          <div className="map-header">
            <h2>Our Integrated Approach to AI & Digital Skills</h2>
            <p>NORA operates AI & Digital Skills programs across all 34 provinces of Afghanistan through experienced instructors and digital platforms</p>
          </div>
          
          <div className="clean-map-container">
            <img 
              src={afgMap} 
              alt="Afghanistan Map - NORA AI & Digital Skills Program Coverage" 
              className="clean-afghanistan-map"
            />
          </div>
        </div>
      </section>

      {/* Scope of Work Section */}
      <section className="scope-work-section">
        <div className="container">
          <div className="scope-cards-grid">
            {scopeOfWork.map((item, index) => (
              <div key={index} className="scope-card">
                <div className="scope-card-header">
                  <i className={item.icon}></i>
                  <h3><strong>Our Integrated Approach to AI & Digital Skills</strong></h3>
                </div>
                <p className="scope-card-description">
                  <strong>Empowering women and youth with Artificial Intelligence and digital skills to create sustainable careers, freelancing opportunities, and technology-driven solutions.</strong>
                  <br/><br/>
                  <strong>AI & Digital Skills</strong>
                  <br/><br/>
                  In today's rapidly evolving digital world, Artificial Intelligence (AI) and digital skills are becoming essential drivers of innovation, employment, and sustainable development. In Afghanistan, many women and youth have limited access to modern technology education due to social, economic, and educational challenges, restricting their ability to participate in the digital economy. Through AI and digital skills development, we equip individuals with future-ready competencies that enable them to innovate, access remote employment opportunities, develop technology solutions, and contribute to Afghanistan's digital transformation.
                  <br/><br/>
                  <strong>To address this challenge, Noor Organization for Rehabilitation of Afghanistan (NORA) has established an integrated AI & Digital Skills Program designed to prepare Afghan women and youth for the jobs of the future.</strong> Leveraging a team of experienced university professors, AI specialists, software engineers, and IT professionals, NORA delivers internationally aligned training that combines theoretical knowledge with practical, project-based experience.
                  <br/><br/>
                  <strong><h3>Our AI & Digital Skills Initiatives:</h3></strong>
                  <br/><br/>
                  <strong>1. Artificial Intelligence Education</strong>
                  <br/>
                  Providing comprehensive training in Artificial Intelligence, Machine Learning, Deep Learning, Computer Vision, Natural Language Processing (NLP), Prompt Engineering, and Generative AI technologies.
                  <br/><br/>
                  <strong>2. Digital Skills Development</strong>
                  <br/>
                  Delivering market-oriented training in Programming, Web Development, Mobile Application Development, Graphic Design (Branding), Cloud Computing, Cybersecurity, Data Science, Networking, Data Analytics, and Digital Productivity tools.
                  <br/><br/>
                  <strong>3. Hands-on Project-Based Learning</strong>
                  <br/>
                  Engaging participants in practical projects, real-world case studies, hackathons, and innovation challenges to strengthen technical competencies and build professional portfolios.
                  <br/><br/>
                  <strong>4. Career Preparation and Freelancing</strong>
                  <br/>
                  Preparing trainees for employment opportunities in both local and international markets through freelancing platforms, remote work, digital entrepreneurship, and startup development.
                  <br/><br/>
                  <strong>5. Innovation and Research</strong>
                  <br/>
                  Promoting innovation through AI research, technology incubation, prototype development, and collaboration with universities, technology companies, and research institutions.
                  <br/><br/>
                  <strong>6. Women's Digital Inclusion</strong>
                  <br/>
                  Creating safe, inclusive, and accessible learning environments that enable Afghan women to acquire advanced digital skills and participate confidently in the digital economy.
                  <br/><br/>
                  <strong>7. Mentorship and Professional Development</strong>
                  <br/>
                  Providing continuous mentorship, technical coaching, career guidance, and networking opportunities with experienced professionals from academia and industry.
                  <br/><br/>
                  <strong><h3>Our Goal</h3></strong>
                  <br/>
                  Our goal is to develop a new generation of Afghan AI and digital professionals who possess the knowledge, practical skills, and innovative mindset required to compete in the global digital economy. Through advanced technology education and innovation, we seek to create sustainable employment opportunities, strengthen Afghanistan's digital ecosystem, and empower women and youth to become leaders in the country's digital transformation.
                  <br/><br/>
                  <strong>A Call for Partnership</strong>
                  <br/><br/>
                  NORA welcomes collaboration with international donors, universities, research institutions, technology companies, AI organizations, and innovation partners to expand access to Artificial Intelligence and Digital Skills education across Afghanistan.
                  <br/>
                  Together, we can prepare Afghanistan's next generation of innovators, researchers, entrepreneurs, and technology leaders while building an inclusive and resilient digital future.
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
};

export default Freelancing;